/**
 * PUT de Schedule de Pronto Atendimento (Location + HCS + Practitioner).
 * Espelha PostSchedule, mas usa builder dedicado — não altera auxiliarData.Schedule.
 */
import * as uuid from "uuid";
import { endpoints } from "@/configs/Settings";
import { HTTPResponseStatus } from "@/utils/enum";
import { useAuth } from "@/utils/useAuth";
import { useAxios } from "@/utils/useAxios";
import {
  buildProntoAtendimentoSchedule,
  type BuildProntoAtendimentoScheduleParams,
} from "./buildProntoAtendimentoSchedule";

type CreateParams = Omit<BuildProntoAtendimentoScheduleParams, "id">;

export async function postProntoAtendimentoSchedule(params: CreateParams) {
  const id = uuid.v1();
  const url = `${endpoints.WORKFLOWFHIR}/Schedule/${id}`;
  const resource = buildProntoAtendimentoSchedule({ ...params, id });

  const headers = {
    Accept: "*/*",
    Authorization: await useAuth.getUserToken(),
    "Content-Type": "application/fhir+json",
  };

  const response = await useAxios
    .put(url, JSON.stringify(resource), { headers, timeout: 20000 })
    .then((res) => {
      if (
        res.status !== HTTPResponseStatus.Success &&
        res.status !== HTTPResponseStatus.Created
      ) {
        throw new Error(`PostProntoAtendimentoSchedule: ${res.status}`);
      }
      return res.data;
    })
    .catch((error) => {
      console.error("postProntoAtendimentoSchedule ", error);
      throw error;
    });

  return response;
}
